/** @format */

import Skeleton from '@material-ui/lab/Skeleton';

const skeletonStyle = { backgroundColor: 'rgba(0, 0, 0, 0.1)' };

const ProgressBarSkeleton = () => (
  <div className="ticket-detail-skeleton__progress">
    {Array.from({ length: 5 }).map((_, index) => (
      <div className="ticket-detail-skeleton__progress-step" key={index}>
        <Skeleton variant="circle" width={32} height={32} style={skeletonStyle} />
        <Skeleton variant="text" width={80} height={20} style={skeletonStyle} />
        {index === 0 && <Skeleton variant="text" width={100} height={16} style={skeletonStyle} />}
      </div>
    ))}
  </div>
);

const TicketInfoSkeleton = () => (
  <div className="ticket-info">
    <div className="ticket-title">
      <Skeleton variant="text" width={120} height={24} style={skeletonStyle} />
      <Skeleton variant="text" width="85%" height={24} style={{ ...skeletonStyle, marginTop: 12 }} />
    </div>
    <div className="ticket-description">
      <Skeleton variant="text" width={160} height={24} style={skeletonStyle} />
      <Skeleton variant="text" width="100%" height={20} style={{ ...skeletonStyle, marginTop: 12 }} />
      <Skeleton variant="text" width="100%" height={20} style={{ ...skeletonStyle, marginTop: 12 }} />
      <Skeleton variant="text" width="95%" height={20} style={{ ...skeletonStyle, marginTop: 12 }} />
      <Skeleton variant="text" width="75%" height={20} style={{ ...skeletonStyle, marginTop: 12 }} />
    </div>
  </div>
);

const CommentsSkeleton = () => (
  <div className="ticket-shadow-box ticket-comments">
    <Skeleton variant="text" width={120} height={24} style={skeletonStyle} />
    {Array.from({ length: 2 }).map((_, index) => (
      <div className="ticket-detail-skeleton__comment" key={index}>
        <div className="ticket-detail-skeleton__comment-header">
          <Skeleton variant="circle" width={32} height={32} style={skeletonStyle} />
          <Skeleton variant="text" width={120} height={20} style={skeletonStyle} />
        </div>
        <Skeleton variant="text" width="100%" height={20} style={skeletonStyle} />
        <Skeleton variant="text" width="90%" height={20} style={{ ...skeletonStyle, marginTop: 12 }} />
      </div>
    ))}
    <div className="comment-btn">
      <Skeleton variant="text" width={140} height={24} style={{ ...skeletonStyle, marginTop: 12 }} />
    </div>
  </div>
);

export const TicketDetailSkeleton = () => (
  <div className="ticket-detail-skeleton">
    <Skeleton variant="text" width={220} height={48} style={skeletonStyle} />
    <Skeleton variant="text" width={180} height={32} style={{ ...skeletonStyle, marginTop: 22 }} />
    <ProgressBarSkeleton />
    <div className="ticket-main">
      <TicketInfoSkeleton />
      <div className="ticket-right-side">
        <CommentsSkeleton />
      </div>
    </div>
  </div>
);
